exports.shouldUpdateScroll = ({ routerProps }) => {
  if (routerProps.location?.state?.scrollToTop === false) {
    return false;
  }

  return true;
};
